/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserCompanyAccessReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The UserCompanyAccessReport model module.
   * @module model/UserCompanyAccessReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserCompanyAccessReport</code>.
   * @alias module:model/UserCompanyAccessReport
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>UserCompanyAccessReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserCompanyAccessReport} obj Optional instance to populate.
   * @return {module:model/UserCompanyAccessReport} The populated <code>UserCompanyAccessReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('CompanyName')) {
        obj['CompanyName'] = ApiClient.convertToType(data['CompanyName'], 'String');
      }
      if (data.hasOwnProperty('CompanyID')) {
        obj['CompanyID'] = ApiClient.convertToType(data['CompanyID'], 'Integer');
      }
      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('Added')) {
        obj['Added'] = ApiClient.convertToType(data['Added'], 'Date');
      }
      if (data.hasOwnProperty('IsUserAdministrator')) {
        obj['IsUserAdministrator'] = ApiClient.convertToType(data['IsUserAdministrator'], 'Integer');
      }
      if (data.hasOwnProperty('SystemUserTypeID')) {
        obj['SystemUserTypeID'] = ApiClient.convertToType(data['SystemUserTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ProfileID')) {
        obj['ProfileID'] = ApiClient.convertToType(data['ProfileID'], 'Integer');
      }
      if (data.hasOwnProperty('TemporaryAccess')) {
        obj['TemporaryAccess'] = ApiClient.convertToType(data['TemporaryAccess'], 'Integer');
      }
      if (data.hasOwnProperty('ShowOnlyPersonalDashboards')) {
        obj['ShowOnlyPersonalDashboards'] = ApiClient.convertToType(data['ShowOnlyPersonalDashboards'], 'Boolean');
      }
      if (data.hasOwnProperty('CustomAccess')) {
        obj['CustomAccess'] = ApiClient.convertToType(data['CustomAccess'], 'Boolean');
      }
      if (data.hasOwnProperty('SpecialMenuID')) {
        obj['SpecialMenuID'] = ApiClient.convertToType(data['SpecialMenuID'], 'Integer');
      }
      if (data.hasOwnProperty('SystemUserRoleID')) {
        obj['SystemUserRoleID'] = ApiClient.convertToType(data['SystemUserRoleID'], 'Integer');
      }
      if (data.hasOwnProperty('IsStrategyFacilitator')) {
        obj['IsStrategyFacilitator'] = ApiClient.convertToType(data['IsStrategyFacilitator'], 'Boolean');
      }
      if (data.hasOwnProperty('UserRoleBillingUserTypeID')) {
        obj['UserRoleBillingUserTypeID'] = ApiClient.convertToType(data['UserRoleBillingUserTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('IsExternalUser')) {
        obj['IsExternalUser'] = ApiClient.convertToType(data['IsExternalUser'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} CompanyName
   * @default ''
   */
  exports.prototype['CompanyName'] = '';
  /**
   * @member {Integer} CompanyID
   * @default 0
   */
  exports.prototype['CompanyID'] = 0;
  /**
   * @member {Integer} UserID
   * @default 0
   */
  exports.prototype['UserID'] = 0;
  /**
   * @member {Date} Added
   */
  exports.prototype['Added'] = undefined;
  /**
   * @member {Integer} IsUserAdministrator
   * @default 0
   */
  exports.prototype['IsUserAdministrator'] = 0;
  /**
   * @member {Integer} SystemUserTypeID
   * @default 0
   */
  exports.prototype['SystemUserTypeID'] = 0;
  /**
   * @member {Integer} ProfileID
   * @default 0
   */
  exports.prototype['ProfileID'] = 0;
  /**
   * @member {Integer} TemporaryAccess
   */
  exports.prototype['TemporaryAccess'] = undefined;
  /**
   * @member {Boolean} ShowOnlyPersonalDashboards
   * @default false
   */
  exports.prototype['ShowOnlyPersonalDashboards'] = false;
  /**
   * @member {Boolean} CustomAccess
   * @default false
   */
  exports.prototype['CustomAccess'] = false;
  /**
   * @member {Integer} SpecialMenuID
   */
  exports.prototype['SpecialMenuID'] = undefined;
  /**
   * @member {Integer} SystemUserRoleID
   * @default 0
   */
  exports.prototype['SystemUserRoleID'] = 0;
  /**
   * @member {Boolean} IsStrategyFacilitator
   * @default false
   */
  exports.prototype['IsStrategyFacilitator'] = false;
  /**
   * @member {Integer} UserRoleBillingUserTypeID
   */
  exports.prototype['UserRoleBillingUserTypeID'] = undefined;
  /**
   * @member {Boolean} IsExternalUser
   * @default false
   */
  exports.prototype['IsExternalUser'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


